import { Game, createBlockGameMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type BlockGameModel = ConfirmModalModel<Game, number, null>;

export const createBlockGameModel = (): BlockGameModel => {
	const blockGameMutation = createBlockGameMutation();

	const model = createConfirmModalModel({
		modalData: declareModalData<Game>(),
		mutation: blockGameMutation,
		mapModalData: ({ id }) => id,
		successMessageKey: 'block-game.success',
	});

	return model;
};
